import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  acceptRequest,
  cancelRequest,
  deleteRequest,
  follow,
  addFriend,
} from "../../functions/user";
import { useToast } from "../../components/ToastContainer";

export default function Card({ userr, type, getData }) {
  const { user } = useSelector((state) => ({ ...state }));
  const { showSuccess, showError } = useToast();
  const cancelRequestHandler = async (userId) => {
    const res = await cancelRequest(userId, user.token);
    if (res === "ok") {
      getData();
    }
  };
  const confirmHandler = async (userId) => {
    const res = await acceptRequest(userId, user.token);
    if (res === "ok") {
      getData();
      showSuccess(`✅ You are now friends with ${userr.name || `${userr.first_name} ${userr.last_name}`}!`, 4000);
    } else {
      showError("❌ Failed to accept friend request. Please try again.", 4000);
    }
  };
  const deleteHandler = async (userId) => {
    const res = await deleteRequest(userId, user.token);
    if (res === "ok") {
      getData();
      showError(`❌ Friend request from ${userr.name || `${userr.first_name} ${userr.last_name}`} declined`, 3000);
    } else {
      showError("❌ Failed to decline friend request. Please try again.", 4000);
    }
  };
  
  const followHandler = async (userId) => {
    const res = await follow(userId, user.token);
    if (res === "ok") {
      getData();
    }
  };
  
  const addFriendHandler = async (userId) => {
    const res = await addFriend(userId, user.token);
    if (res === "ok") {
      getData();
    }
  };
  return (
    <div className={`req_card${type === "sent" ? " sent_req_card" : ""}`}>
      <Link to={`/profile/${userr.username}`}>
        <img src={userr.picture} alt="" />
      </Link>
      <div className="req_name">
        {userr.name || `${userr.first_name || ""} ${userr.last_name || ""}`.trim()}
      </div>
      {type === "sent" ? (
        <button
          className="blue_btn sent_cancel_btn"
          onClick={() => cancelRequestHandler(userr._id)}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
          </svg>
          Cancel Request
        </button>
      ) : type === "request" ? (
        <>
          <button
            className="blue_btn request_confirm_btn"
            onClick={() => confirmHandler(userr._id)}
          >
            Confirm
          </button>
          <button className="gray_btn" onClick={() => deleteHandler(userr._id)}>
            Delete
          </button>
        </>
      ) : type === "suggestion" ? (
        <div className="suggestion_buttons">
          <button
            className="blue_btn pymk_add_btn"
            onClick={() => addFriendHandler(userr._id)}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
              <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="1.8" />
              <path d="M19 8v6M22 11h-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
            Add Friend
          </button>
          <button
            className="gray_btn pymk_follow_btn"
            onClick={() => followHandler(userr._id)}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinejoin="round"
              />
            </svg>
            Follow
          </button>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
